"use client";

import Image from "next/image";
import { motion } from "@/lib/motion";
import { Images } from "@/assests";
import { G2_URL, TRUST_CENTER_URL } from "@/lib/constants";
import SectionHeader from "@/components/ui/section-header";

const badges = [
  {
    id: "g2-users",
    src: Images.g2UsersLoveUs,
    alt: "G2 — Users Love Us",
    label: "Users Love Us",
    platform: "G2",
    needsWhiteBg: false,
    href: G2_URL,
  },
  {
    id: "g2-medal",
    src: Images.g2Medal,
    alt: "G2 — High Performer Medal",
    label: "High Performer",
    platform: "G2",
    needsWhiteBg: false,
    href: G2_URL,
  },
  {
    id: "soc2",
    src: Images.soc2,
    alt: "SOC 2 Certified",
    label: "SOC 2 Certified",
    platform: "AICPA",
    needsWhiteBg: false,
    href: TRUST_CENTER_URL,
  },
  {
    id: "iso27001",
    src: Images.iso27001,
    alt: "ISO 27001 Certified",
    label: "ISO 27001 Certified",
    platform: "Sensiba",
    needsWhiteBg: false,
    href: TRUST_CENTER_URL,
  },
];

export default function BadgesSection() {
  return (
    <section className="py-section border-border border-b" aria-labelledby="badges-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center">
          <SectionHeader
            eyebrow="Recognition"
            id="badges-heading"
            align="center"
            heading="Trusted. Certified. Recognized."
            body="SOC 2 Type II attested and ISO/IEC 27001 certified. Review current reports and certificates in the Proxidize Trust Center."
          />
        </div>

        <div
          className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4"
          aria-label="Awards and certifications"
        >
          {badges.map((badge) => {
            const sharedClass =
              "relative flex flex-col items-center gap-4 p-6 bg-card card-wash border-border rounded-2xl border hover:bg-muted/40 transition-colors cursor-pointer overflow-hidden group";
            const body = (
              <>
                <div
                  className={[
                    "relative flex w-full items-center justify-center",
                    badge.needsWhiteBg ? "rounded-lg bg-white p-3" : "",
                  ].join(" ")}
                  style={{ height: 100 }}
                >
                  <Image
                    src={badge.src}
                    alt=""
                    fill
                    className={["object-contain", badge.needsWhiteBg ? "p-2" : ""].join(" ")}
                    sizes="(max-width: 640px) 50vw, (max-width: 1024px) 25vw, 280px"
                    unoptimized={badge.src.endsWith(".svg")}
                  />
                </div>

                <div className="text-center">
                  <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
                    {badge.platform}
                  </p>
                  <p className="text-foreground mt-0.5 text-sm font-bold">{badge.label}</p>
                </div>
              </>
            );
            return (
              <motion.a
                key={badge.id}
                href={badge.href}
                target="_blank"
                rel="noopener noreferrer"
                className={sharedClass}
              >
                {body}
                <span className="sr-only"> (opens in new tab)</span>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
